import { AudienceChannelSourceFilters } from '@/features/broadcasters/types';
import { ParamsWithPagination } from '@/types/api';

import { AudienceFilters } from '../types';

export const audiencesQueryKeys = {
  all: ['audiences'] as const,
  lists: () => [...audiencesQueryKeys.all, 'lists'] as const,
  list: (params?: ParamsWithPagination<AudienceFilters>) =>
    [...audiencesQueryKeys.lists(), params] as const,
};

export const audienceChannelSourcesQueryKeys = {
  all: ['audience_channel_sources'] as const,
  lists: () => [...audienceChannelSourcesQueryKeys.all, 'lists'] as const,
  list: (params?: ParamsWithPagination<AudienceChannelSourceFilters>) =>
    [...audienceChannelSourcesQueryKeys.lists(), params] as const,
};
